import { useState, useEffect, useRef, useMemo } from "react";
import { eChartColours, getMainColors } from "constants/colors";
import { Card, Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { DasboardWidgetTitle } from "components/DasboardWidgetTitle";
import { useAppSelector } from "redux/hooks";
import { RootState } from "redux/store";
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from "echarts";

const CustomersChart = () => {
    const colors = getMainColors();
    const dashboard = useAppSelector((state: RootState) => state.dashboard);
    const chartRef = useRef<ReactECharts>(null);

    const chartOptions: EChartsOption = useMemo<EChartsOption>(() => {

        const data = [dashboard.customerData.mobileGraph, dashboard.customerData.emailsGraph, dashboard.customerData.aslConsentGraph, dashboard.customerData.scriptsOnFileGraph];
        const names = ["Mobiles", "Email", "ASL", "Rx Held"];

        const retData: EChartsOption = {
            color: eChartColours,
            animationDuration: 300,
            polar: {
                radius: [70, '90%'],
            },
            grid: {
                top: 0,
                left: 0,
                right: 0,
                bottom: '60%',
            },
            angleAxis: {
                max: 100,
                startAngle: 90,
                show: false,
                splitLine: {
                    show: false
                },
                axisLine: {
                    show: false
                },
            },
            radiusAxis: {
                type: 'category',
                data: [],
            },

            series: data.map((e, i) => (
                {
                    type: 'bar',
                    data: [e],
                    coordinateSystem: 'polar',
                    label: {
                        show: false,
                        position: 'middle',
                        formatter: '{b}: {c}'
                    },
                    name: names[i],
                    showBackground: true,
                })
            ),

            tooltip: {
                formatter: '{a}: {c}%'
            },
            legend: {
                data: names,
                formatter: (name: string) => name + ": " + data[names.findIndex(i => i === name)] + "%",
                bottom: 0,
                show: true,
                type: 'scroll',
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title: 'Save',
                        name: `Customer Export`,
                    },
                }
            }
        };

        return retData;
    }, [dashboard.customerData]);

    return (
        <Card style={{ marginBottom: "0px", height: '100%', minHeight: "400px" }}>
            <Card.Body className="ps-2 d-flex flex-column">
                <Row className="p-0">
                    <Col xs={12} sm={6} className="ps-2">
                        <h4 className="dasboard-widget-title w-fit">Customers <i className="ps-1 widget-icon mdi mdi-account-multiple"></i></h4>
                    </Col>
                    <Col xs={12} sm={6} className="p-0 d-flex justify-content-end">
                        <div className="d-inline-flex">
                            {dashboard.customerData.activeTotal > 0 && <div className="me-1">Total Active: {dashboard.customerData.activeTotal}</div>}
                            <div className="pe-2">
                                <OverlayTrigger placement="left"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">Customers who in the last 6 months have had 5 or more scripts</Tooltip>
                                    }
                                >
                                    <i className="mdi mdi-information dasboard-widget-title float-end d-flex justify-content-end align-items-center"></i>
                                </OverlayTrigger>
                            </div>
                        </div>
                    </Col>
                </Row>
                
                <Row className="d-flex flex-grow pt-1">
                    <ReactECharts
                        ref={chartRef}
                        option={chartOptions}
                        className="h-100 w-100 d-flex flex-grow"
                    />
                </Row>
            </Card.Body>
        </Card>
    );
};

export default CustomersChart;
